import { Controller } from "@hotwired/stimulus";

// walk/ORG.md § The shell: the (u) sheet, shared/_menu.
//
// The sheet is a native popover, so Esc, a tap outside and focus back on the
// avatar are the browser's. What a popover does not do is keep Tab inside, and
// below lg the sheet covers the page: Tab would walk onto controls nobody can
// see. Same answer as peel_controller: while it is open, everything that is
// not on the way to the sheet is inert.
//
// From lg up it is a small dropdown over a page still in use: nothing is
// inert. (Resizing across lg with it open waits for the next open.)
export default class extends Controller {
  held = [];

  // beforetoggle, not toggle: closing, it fires before the browser hands focus
  // back to the avatar, which an inert avatar would refuse.
  toggle(event) {
    if (event.newState === "open" && !matchMedia("(min-width: 64rem)").matches)
      this.hold();
    else this.release();
  }

  // Every sibling on the way from the sheet up to <body> goes inert; the
  // ancestors stay live, or the sheet (inside <header>) would go with them.
  // The phone app's `hidden` button bar is skipped: nobody tabs into it, and
  // the shell's own taps click it while the sheet is open.
  // The (u) that opened it stays live too: Chrome moves no Tab off a focused
  // element gone inert, so every stop would be <body>. Its box is walked
  // into, so only the invoker and the way to it stay out of the hold.
  hold() {
    const invokers = [
      ...document.querySelectorAll(`[popovertarget="${this.element.id}"]`),
    ];
    const hold = (el) => {
      if (invokers.includes(el) || el.inert || el.hidden) return;
      if (invokers.some((i) => el.contains(i))) [...el.children].forEach(hold);
      else this.held.push(el);
    };
    for (
      let node = this.element;
      node !== document.body;
      node = node.parentElement
    )
      for (const el of node.parentElement.children) if (el !== node) hold(el);
    this.held.forEach((el) => (el.inert = true));
  }

  // Only what hold() set is put back, never what was inert before. Also run
  // as turbo:before-cache, or the back button would restore an inert page.
  release() {
    this.held.forEach((el) => (el.inert = false));
    this.held = [];
  }

  disconnect() {
    this.release();
  }
}
